var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChestnut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62 32c0 15.5-13.4 28-30 28S2 47.5 2 32S32 4 32 4s30 12.5 30 28z",
    fill: "#947151"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 50.9c-10.3 0-19.9-3.1-27.7-8.3C8.8 52.8 19.5 60 32 60s23.2-7.2 27.7-17.3c-7.8 5.2-17.4 8.2-27.7 8.2",
    fill: "#e0ac7e"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#846144"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 4c-3.4 3-6.7 6-9.8 9.2c-1.5 1.6-3 3.2-4.3 5c-1.4 1.7-2.6 3.5-3.7 5.4c-2.2 3.7-3.7 7.8-3.6 12c0 4.2 1.6 8.4 4.1 12.3c-1.7-1.5-3.2-3.3-4.3-5.4c-1.1-2.1-1.9-4.4-2.1-6.8c-.3-2.4 0-4.8.6-7.1s1.6-4.5 2.8-6.5c2.4-4 5.5-7.5 9-10.5C24.1 8.5 27.9 6 32 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 4c4.1 2 7.9 4.5 11.4 7.5S50 18 52.4 22c1.2 2 2.2 4.2 2.8 6.5c.6 2.3.9 4.8.6 7.1c-.2 2.4-1 4.7-2.1 6.8c-1.1 2-2.6 3.9-4.3 5.4c2.4-3.8 4.1-8 4.1-12.3c0-4.2-1.5-8.3-3.6-12c-1.1-1.9-2.3-3.6-3.7-5.4c-1.3-1.7-2.8-3.4-4.3-5C38.7 10 35.4 7 32 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 4c-1.3 4.1-2.6 7.9-3.9 11.8c-1.3 3.9-2.6 7.7-3.6 11.5s-1.8 7.7-2 11.5c-.2 3.9.2 7.7 2.1 11.6c-1.8-1.2-3.2-3-4.2-5s-1.6-4.2-1.9-6.4c-.6-4.4 0-8.8 1.1-13c1.1-4.2 2.8-8.1 4.8-11.8C26.6 10.5 29 7 32 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 4c3 3 5.4 6.5 7.5 10.2c2 3.7 3.7 7.7 4.8 11.8c1.1 4.1 1.7 8.6 1.1 13c-.3 2.2-.9 4.4-1.9 6.4c-1 2-2.4 3.8-4.2 5c1.9-3.8 2.3-7.7 2.1-11.6c-.2-3.9-1-7.7-2-11.5s-2.3-7.7-3.6-11.5C34.6 11.9 33.3 8.1 32 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 4c1 3.9 1.6 7.8 2 11.7c.4 3.9.5 7.8.5 11.7c0 3.9-.2 7.8-.5 11.7c-.4 3.9-.9 7.8-2 11.7c-1-3.9-1.6-7.8-2-11.7c-.4-3.9-.5-7.8-.5-11.7c0-3.9.2-7.8.5-11.7c.4-3.9 1-7.8 2-11.7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChestnut);
export default __webpack_public_path__ + "static/media/chestnut.03c6793510bd237f88417c585e8fa9e4.svg";
export { ForwardRef as ReactComponent };